import React from "react";
import useIsUkUserCountry from "src/utils/hooks/useIsUkUserCountry";
import WarningCallout from "./WarningCallout";

const LEARN_MORE_URL = "https://calebandbrown.com/en-gb/risk-summary";

/**
 * UK-only crypto risk warning shown on the trading (CTA) pages.
 * Renders nothing for users whose address is outside the UK.
 */
export const CryptoRiskWarning: React.FC = () => {
  const isUkUser = useIsUkUserCountry();

  if (!isUkUser) return null;

  return (
    <WarningCallout sx={{ mb: 1.5 }}>
      <strong>Crypto Assets are High Risk and Volatile.</strong> Do not invest more than you are
      willing to lose. To learn more read{" "}
      <a href={LEARN_MORE_URL} target="_blank" rel="noopener noreferrer">
        here
      </a>
    </WarningCallout>
  );
};

export default CryptoRiskWarning;
